'use client';
import { useEffect } from 'react';

 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import HeroSection from'./components/HeroSection';
 import HowItWorksSection from'./components/HowItWorksSection';
 import ProductenSection from'./components/ProductenSection';
 import ComparisonSection from'./components/ComparisonSection';
 import ReviewsSection from'./components/ReviewsSection';
 import HousingTypeSection from'./components/HousingTypeSection';
 import ContactFormSection from'./components/ContactFormSection';
 import StickyCTAButton from'./components/StickyCTAButton';

export default function Homepage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach((el) => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <HeroSection />
        <HowItWorksSection />
        <ProductenSection />
        <ComparisonSection />
        <ReviewsSection />
        <HousingTypeSection />
        <ContactFormSection />
        <StickyCTAButton />
      </main>
      <Footer />
    </>
  )
}